import React from 'react';
import { useT } from '../i18n/LanguageContext';
export const helpStatuses = {
  needs_support: 'Needs support',
  waiting_on_user: 'Waiting on user',
  resolved: 'Resolved',
};
export const accountRoles = {
  clinic: 'Clinic',
  sales_rep: 'Sales Rep',
  admin: 'Admin',
  master_distributor: 'Distributor',
};

export function HelpAudience({ request }) {
  const t = useT();
  return (
    request?.businessContext && (
      <span className="hc-audience">
        {request.businessContext === 'distributor' ? (
          <>
            {t('Distributor')}: {request.distributor?.name || t('Distributor')}
            {request.clinic && (
              <>
                {' '}
                | {t('Clinic')}: {request.clinic.name}
              </>
            )}
          </>
        ) : (
          t('Direct MedEffects request')
        )}
      </span>
    )
  );
}

export function helpPreviewKey(event, previewDialog, closePreview) {
  if (event.key === 'Escape') {
    event.preventDefault();
    closePreview();
    return;
  }
  if (event.key !== 'Tab') return;
  const nodes = Array.from(
    previewDialog.current.querySelectorAll('button:not(:disabled),a[href],iframe')
  );
  const first = nodes[0];
  const last = nodes[nodes.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last?.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first?.focus();
  }
}

export const mergeMessages = (old, incoming) =>
  Array.from(
    new Map([...old, ...incoming].map((message) => [message.sequence, message])).values()
  ).sort((a, b) => a.sequence - b.sequence);

export const helpDate = (value, locale) =>
  new Date(value).toLocaleString(locale, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
